export const DEFAULTS = {
  QUERY: {
    OFFSET: 0,
    LIMIT: 20,
    MAX_LIMIT: 500,
  },
}
